import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Shaved! \\o/",
  "description": "",
  "published": "2009-12-01T00:00:00.000Z",
  "redirect_from": ["/blog/shaved-o/swizec/928"],
  "categories": "Fashion, funny, Hair, intrigues, life, Men, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Throughout the month of November those of us not afraid of our masculinity fought for the right of all men all over the world to refuse feminisation and fight neutirisation and all other things that make us less manly. As some smart bloke in the bible once said `}<em parentName="p">{`Ye shall not round the corners of your heads, neither shalt thou mar the corners of thy beard.`}</em>{` For any heathen that knows not what `}<a parentName="p" {...{
        "href": "http://www.urbandictionary.com/define.php?term=beardvember"
      }}>{`beardvember`}</a>{` is `}<a parentName="p" {...{
        "href": "http://www.urbandictionary.com/define.php?term=beardvember"
      }}>{`this helpful link`}</a>{` might shed some light upon the matter. For all the rest, here are some pictures of my masculinity popping out upon my face like mushrooms on a rainy afternoon.`}</p>
    <p>{`To catalogue the event I wanted to take a photo of my face every day and then produce a funky video ... but I only took 16 rather than 30. :)`}</p>
    <p>{`So yeah, rather silly the whole thing and you can't believe my joy when I finally got to shave all that pesky hair off ... but nontheless, I still sort of miss it.`}</p>
    <p>{`Oh and I totally posted this way later than planned because of software trouble with creating the video.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/fa2090fd-d9f5-4915-bdbc-879d930dda77/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=fa2090fd-d9f5-4915-bdbc-879d930dda77",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      